var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgInsomnia = function SvgInsomnia(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "insomnia_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7400E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4000BF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M128 249.491c67.098 0 121.492-54.393 121.492-121.491S195.098 6.508 128 6.508C60.902 6.508 6.509 60.902 6.509 128c0 67.098 54.393 121.491 121.491 121.491Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4000BF",
    d: "M128 0C57.308 0 0 57.308 0 128c0 70.693 57.308 128 128 128 70.693 0 128-57.307 128-128C256 57.308 198.693 0 128 0Zm0 13.017c63.503 0 114.983 51.48 114.983 114.983 0 63.503-51.48 114.983-114.983 114.983-63.503 0-114.983-51.48-114.983-114.983 0-63.503 51.48-114.983 114.983-114.983Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#insomnia_svg__a)",
    d: "M129.446 36.881c50.324 0 91.119 40.796 91.119 91.119s-40.795 91.118-91.12 91.118c-50.323 0-91.118-40.795-91.118-91.118 0-12.298 2.437-24.028 6.854-34.733 6.449 8.783 16.85 14.484 28.581 14.484 19.57 0 35.435-15.865 35.435-35.435 0-11.732-5.701-22.132-14.484-28.581 10.705-4.417 22.434-6.854 34.733-6.854Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInsomnia);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;